export default __webpack_public_path__ + "locales/fr/Errors.json?hash=1460545adec1f306179f6fcbb98c0ea0";